import { PlacardVersion, PageSize } from "constants/pdf";

import { createAndOpenPdf, preparePlacardLogos } from "lib/pdf";

import { getContentForPlacardV1 } from "./Placard";
import { getContentForPlacardV2 } from "./PlacardV2";
import { getContentForPlacardV3 } from "./PlacardV3";
import { getContentForPlacardV4 } from "./PlacardV4";
import { getContentForPlacardV5 } from "./PlacardV5";

export const preparePlacard = (
  saleLots,
  sale,
  deploymentIdBySaleLotIdLookup,
  deployments,
  vendorBySaleLotIdLookup,
  isVendorBredBySaleLotIdLookup,
  suppressBack,
  includeWeight,
  size = PageSize.A3,
  orientation = "landscape",
  version,
  deploymentPlacardLogos = [],
  isNeeAccreditedLookup = [],
) => {
  const contentDefintion = {
    pageMargins: [12, 12, 12, 12],
    content: null,
  };

  switch (version) {
    case PlacardVersion.V2:
      contentDefintion.content = getContentForPlacardV2(
        saleLots,
        deploymentIdBySaleLotIdLookup,
        deployments,
        vendorBySaleLotIdLookup,
        isVendorBredBySaleLotIdLookup,
        isNeeAccreditedLookup,
      );
      break;
    case PlacardVersion.V3:
      contentDefintion.pageMargins = [12, 80, 12, 40];
      contentDefintion.content = getContentForPlacardV3(
        saleLots,
        deploymentIdBySaleLotIdLookup,
        deployments,
        vendorBySaleLotIdLookup,
        isVendorBredBySaleLotIdLookup,
        includeWeight,
        size,
      );
      break;
    case PlacardVersion.V4:
      contentDefintion.content = getContentForPlacardV4(
        saleLots,
        deploymentIdBySaleLotIdLookup,
        deployments,
        vendorBySaleLotIdLookup,
        isVendorBredBySaleLotIdLookup,
      );
      break;
    case PlacardVersion.V5:
      contentDefintion.content = getContentForPlacardV5(
        saleLots,
        deploymentIdBySaleLotIdLookup,
        deployments,
        vendorBySaleLotIdLookup,
        isVendorBredBySaleLotIdLookup,
      );
      break;
    default:
      contentDefintion.content = getContentForPlacardV1(
        saleLots,
        deploymentIdBySaleLotIdLookup,
        deployments,
        vendorBySaleLotIdLookup,
        isVendorBredBySaleLotIdLookup,
      );
  }

  const pdfDefinition = {
    ...contentDefintion,
    pageSize: size,
    pageOrientation: orientation,
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 11,
      },
      contentStyle: {
        fontSize: 40,
        overflow: "hidden",
        display: "inline-block",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        margin: [15, 30, 15, 15],
      },
    },
    images: preparePlacardLogos(sale, deploymentPlacardLogos),
  };
  createAndOpenPdf(pdfDefinition, undefined, suppressBack);
};
